import {
  LangState,
  LanguageItemProps,
} from '../../../interfaces/reducers/languageItem';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

const initialState: LangState = {
  language: null,
};

export const LanguageSlice = createSlice({
  name: 'lang',
  initialState,
  reducers: {
    setLanguage: (
      state,
      action: PayloadAction<{language: LanguageItemProps}>,
    ) => {
      state.language = action.payload.language;
    },
  },
});

// Action creators are generated for each case reducer function
export const {setLanguage} = LanguageSlice.actions;

export default LanguageSlice.reducer;
